module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kQKrJ"))).then(() => parcelRequire('8rm4T'));